import type { CSSProperties } from "react"
import type { EmailIntegration } from "@/schema"

export type EmailEditorProvider = EmailIntegration["provider"]
export type EmailStyleProvider = "gmail" | "outlook"

interface EmailEditorProfile {
  provider: EmailStyleProvider
  contentStyle: CSSProperties
  fontSize: string
  textColor: string
}

const GMAIL_PROFILE: EmailEditorProfile = {
  provider: "gmail",
  contentStyle: {
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: "13px",
    lineHeight: "1.5",
  },
  fontSize: "13px",
  textColor: "#222222",
}

const OUTLOOK_PROFILE: EmailEditorProfile = {
  provider: "outlook",
  contentStyle: {
    fontFamily: "Aptos, Aptos_EmbeddedFont, Aptos_MSFontService, Calibri, Helvetica, sans-serif",
    fontSize: "12pt",
    lineHeight: "1.21875",
  },
  fontSize: "12pt",
  textColor: "#000000",
}

export function getEmailEditorProfile(provider?: EmailEditorProvider): EmailEditorProfile {
  return provider === "microsoft" || provider === "exchange" ? OUTLOOK_PROFILE : GMAIL_PROFILE
}
